module.exports = __webpack_public_path__ + "img/1493233550.36b5d83e.jpg";